<div class="d-flex align-items-center justify-content-between right-side-panel-header-wrapper">
  <span class=" right-panel-title label-h3">{{rightPanelTitle}}</span>
  <button  (click)="closeRightPanel()" class="btn btn-text justify-content-center align-items-center">
    <img lib-amdocs-image-version src="/assets/icons/close-purple.svg">
  </button>
</div>
